export default __webpack_public_path__ + "static/logoMini-95c2e75f37779ad3ae3936200e4e36ee.png";